export default __webpack_public_path__ + "static/media/2.6a84b567.png";